import PaginatedList from '@theme/paginated-list';
import { startViewTransition } from '@theme/utilities';

/**
 * A custom element that renders a paginated list of results (collection and
 * search pages) and lets the shopper switch the grid density.
 *
 * Extends {@link PaginatedList} for pagination / infinite scroll and adds the
 * grid layout (density) toggle wired up via `on:change="results-list/updateLayout"`
 * in `snippets/grid-density-controls.liquid`.
 *
 * @extends {PaginatedList}
 */
export default class ResultsList extends PaginatedList {
  /**
   * Updates the product grid layout in response to the grid density controls.
   *
   * The selected layout is written to the grid's `product-grid-view` attribute
   * (which the CSS in `snippets/product-grid.liquid` keys off) and persisted to
   * `sessionStorage` so the choice survives section re-renders and navigation.
   * The inline script in `snippets/product-grid.liquid` reads these same keys to
   * restore the layout on the next page load.
   *
   * @param {Event} event - The change event dispatched by the radio input.
   */
  updateLayout(event) {
    const { grid } = this.refs;
    const input = event.target;

    if (!grid || !(input instanceof HTMLInputElement)) return;

    const isMobile = input.name === 'grid-mobile';
    const storageKey = isMobile ? 'product-grid-view-mobile' : 'product-grid-view-desktop';

    sessionStorage.setItem(storageKey, input.value);

    startViewTransition(() => {
      grid.setAttribute('product-grid-view', input.value);
    });
  }
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
